import ContactUsPage from "./ContactUsPage";
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import UserAgreementPage from "./UserAgreementPage";

export default function LegalPage({type, isMusicOn, onMusicToggle, mobile = false}) {
    const pageProps = {isMusicOn, onMusicToggle, mobile};

    if (type === "privacy-policy") return <PrivacyPolicyPage {...pageProps} />;
    if (type === "contact-us") return <ContactUsPage {...pageProps} />;
    return <UserAgreementPage {...pageProps} />;
}
